module.exports = __webpack_public_path__ + "img/block-mark.1e183a95.svg";